import { Language } from "../../context";

export const exhibitionProgramListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/exhibition-program-en.json",
  [Language.ZH_TW]: "/data/tc/exhibition-program-tc.json",
  [Language.ZH_CN]: "/data/sc/exhibition-program-sc.json",
};
export function getExhibitionProgramSubPage(jsonData: any[]): string {
  return jsonData?.map((item) => item?.content)?.[0] ?? "";
}
